module.exports = __webpack_public_path__ + "static/media/june2024-5.9779f539.webp";